import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useWebsiteSettings from '../hooks/useWebsiteSettings';
import { FaFacebook, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  const { t } = useTranslation();
  const { settings } = useWebsiteSettings();

  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="container mx-auto px-6 py-20">
        <div className="grid md:grid-cols-4 gap-16">
          <div className="col-span-2">
            <div className="flex items-center space-x-3 mb-8">
              <img 
                src={settings.faviconUrl ? settings.faviconUrl : "/STAPOTECHPRIMARY goen zwart png.png"} 
                alt="Stapotech Favicon" 
                className="h-40" 
              />
            </div>
            <p className="text-gray-600 font-light leading-relaxed mb-8 max-w-md">
              {t('footer.description')}
            </p>
            
          </div>

          <div>
            <h4 className="text-lg font-light text-gray-900 mb-8 tracking-wider">{t('footer.services')}</h4>
            <ul className="space-y-4 text-gray-600 font-light">
              <li><Link to="/portfolio" className="hover:text-gray-900 transition-colors">{t('footer.servicesList.hijsinstallaties')}</Link></li>
              <li><Link to="/portfolio" className="hover:text-gray-900 transition-colors">{t('footer.servicesList.vloeren')}</Link></li>
              <li><Link to="/portfolio" className="hover:text-gray-900 transition-colors">{t('footer.servicesList.draaitonelen')}</Link></li>
              <li><Link to="/portfolio" className="hover:text-gray-900 transition-colors">{t('footer.servicesList.trussen')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-light text-gray-900 mb-8 tracking-wider">{t('footer.company')}</h4>
            <ul className="space-y-4 text-gray-600 font-light">
              <li><Link to="/about" className="hover:text-gray-900 transition-colors">{t('footer.companyList.about')}</Link></li>
              <li><Link to="/portfolio" className="hover:text-gray-900 transition-colors">{t('footer.companyList.portfolio')}</Link></li>
              <li><Link to="/contact" className="hover:text-gray-900 transition-colors">{t('footer.companyList.contact')}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-light text-gray-900 mb-8 tracking-wider">{t('footer.followUs')}</h4>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/Stapotech/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900">
                <FaFacebook size={24} />
              </a>
              <a href="https://www.linkedin.com/company/stapotech-bv/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900">
                <FaLinkedin size={24} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-100 mt-16 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm font-light">
              {t('footer.copyright')}
            </p>
            <div className="flex space-x-8 mt-4 md:mt-0">
              <Link to="#" className="text-gray-400 hover:text-gray-900 text-sm font-light transition-colors">
                {t('footer.privacy')}
              </Link>
              <Link to="#" className="text-gray-400 hover:text-gray-900 text-sm font-light transition-colors">
                {t('footer.terms')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;